import React from 'react';

import { OpenChatLink as OpenChat } from '@r1-frontend/entities/Chat';

import { Message } from './styled';

interface IRenderMessageProps {
    isError: boolean,
    message: string | null | undefined,
}

const RenderMessage = ({
    isError,
    message,
}: IRenderMessageProps) => {
    if (isError && message === undefined) {
        return <Message isError={isError}>
            Неизвестная ошибка, попробуйте оставить заявку позднее
            или напишите нам в&nbsp;<OpenChat/>.
        </Message>;
    }

    if (message == null) {
        return null;
    }

    return <Message isError={isError}>
        {message}
    </Message>;
};

export default RenderMessage;
